import React from 'react'
import PropTypes from 'prop-types'
import MultiSelectPicker from '../MultiSelectPicker'
import { CONTENT_FILTER_OPTIONS } from './constants'
const formatSelectedLabel = (count, labels) => {
  if (count === CONTENT_FILTER_OPTIONS.length)
    return 'Tous les contenus'
  return labels.join(', ')
}

const ContentFilter = ({ value, onChange }) => (
  <MultiSelectPicker
    formatSelectedLabel={formatSelectedLabel}
    options={CONTENT_FILTER_OPTIONS}
    placeholder="Type de contenu"
    searchable={false}
    selectedValues={value}
    onChange={onChange}
  />
)

ContentFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default ContentFilter
